

import React, { useRef, useState, useEffect } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import AlertMessage from "../../AlertMessage";
import moment from 'moment';
import 'firebase/compat/database';
import Watermark from '../../assets/images/Watermark.png'


function Bonadoc({ submitted, formData, isStudentActive }) {
  const [schoolData, setSchoolData] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isFreeTrial, setIsFreeTrial] = useState(false); // Added state for free trial status
  const [currentThemeIndex, setCurrentThemeIndex] = useState(0);
  const [isDefaultTheme, setIsDefaultTheme] = useState(false);

  // console.log("formdata", formData);

  const language = localStorage.getItem("language") || "English";
  const [logoURL, setLogoURL] = useState("");
  const [logoURL2, setLogoURL2] = useState("");
  const [loading, setLoading] = useState(true);
  const udiseNumber = localStorage.getItem("udiseNumber");


  const affiliationRef = useRef(null);
  const recognitionRef = useRef(null);
  const [isStacked, setIsStacked] = useState(false);

  useEffect(() => {
    const checkWidth = () => {
      if (affiliationRef.current && recognitionRef.current) {
        const totalWidth = affiliationRef.current.offsetWidth + recognitionRef.current.offsetWidth;
        const availableWidth = 7.6 * 96 - 200; // Assuming 7.6 inches width and 100px logos on each side (200px total)
        setIsStacked(totalWidth > availableWidth);
      }
    };
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, [schoolData, formData]);

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const [duplicate, setDuplicate] = useState(false);
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);

      request.onerror = (event) => {
        console.error('Database error:', event.target.error);
        reject('Error opening IndexedDB');
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      // If the database doesn't exist yet, create it
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };


  // Fetch pack activation status from Firebase
  useEffect(() => {
    if (udiseNumber) {
      const dbRef = firebase.database().ref(`/Admin/${udiseNumber}`);
      dbRef.once('value').then((snapshot) => {
        const data = snapshot.val();
        if (data && data.packActivated === "freeTrial") {
          setIsFreeTrial(true);
        } else {
          setIsFreeTrial(false);
        }
      }).catch(error => {
        console.error("Error fetching pack activation status:", error);
      });
    }
  }, [udiseNumber]);



  const [isCollege, setIsCollege] = useState(true);
  const [isSchool, setIsSchool] = useState(true);
  const [isPrincipal, setIsPrincipal] = useState(true);
  const [isDean, setIsDean] = useState(true);

  const institutionWordEnglish = isCollege && isSchool
    ? "school/college"
    : isCollege
      ? "college"
      : isSchool
        ? "school"
        : "school/college";

  const institutionWordMarathi = isCollege && isSchool
    ? "शाळेत/कॉलेजमध्ये"
    : isCollege
      ? "कॉलेजमध्ये"
      : isSchool
        ? "शाळेत"
        : "शाळेत/कॉलेजमध्ये";

  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['defaultSettings'], 'readonly');
        const objectStore = transaction.objectStore('defaultSettings');
        const request = objectStore.get('defaultSettings');

        request.onsuccess = (event) => {
          const data = event.target.result;

          if (data) {
            console.log("data", data);

            setIsCollege(data.isCollege)
            setIsDean(data.isDean)
            setIsPrincipal(data.isPrincipal)
            setIsSchool(data.isSchool)
          } else {
            console.warn("No default settings found for the key 'defaultSettings'.");
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching default settings:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching default year:', error);
      }
    }
    fetchDefaultSettings();
  }, [udiseNumber]);




  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  useEffect(() => {
    if (udiseNumber) {
      fetchSchoolData(udiseNumber);
    }
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize); // Clean up event listener
  }, []);

  const fetchSchoolData = async (udiseNumber) => {
    try {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onsuccess = async (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setLogoURL(data.schoolLogo); // Set the logo URL
            setLogoURL2(data.schoolLogo2); // Set the logo URL
          }
          setLoading(false);
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
          setLoading(false);
        };
      };

      request.onerror = (event) => {
        console.error("Error opening IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error fetching school data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log("isCollege:", isCollege, "isSchool:", isSchool);
  }, [isCollege, isSchool]);

  const renderContent = () => {
    if (!schoolData || !formData) return null;

    return (
      <div
        style={{
          position: "absolute",
          top: "0.9in", // Move the box to the top of the page
          right: "0.30in",
          width: "7.6in", // 8.5in - 0.4in (0.2in on each side)
          height: "5.35in", // Adjust the height as needed
          padding: "0.2in", // Adjust padding to create the margin inside the border
          fontFamily: "'NotoSansDevanagari', sans-serif",
          border: "0.03in solid black",
          boxSizing: "border-box",


          '@media (max-width: 1200px)': {
            width: '7in', // Adjust width for medium screens
            height: '5in', // Adjust height for medium screens
          },
          '@media (max-width: 992px)': {
            width: '6.5in', // Adjust width for smaller screens
            height: '4.8in', // Adjust height for smaller screens
          },
          '@media (max-width: 768px)': {
            width: '6in',
            height: '4.6in',
          },
          '@media (max-width: 576px)': {
            width: '100%',
            left: '0.2in',
            height: 'auto',
          }
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "0.55in",
            left: "0.081in",
          }}
        >
          {logoURL && (
            <img
              src={logoURL}
              alt="School Logo"
              style={{ width: "100px", height: "100px" }}
            />
          )}
        </div>

        <div
          style={{
            position: "absolute",
            top: "0.55in",
            right: "0.081in",
          }}
        >
          {logoURL2 && (
            <img
              src={logoURL2}
              alt="School Logo"
              style={{ width: "100px", height: "100px" }}
            />
          )}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {schoolData.sansthaName && (
            <div
              style={{
                fontSize: '11px',
                fontWeight: 'bold',
                wordWrap: 'break-word',
                textAlign: 'center',
                marginTop: '-15px', // add this
              }}
            >
              {schoolData.sansthaName}
            </div>
          )}
          <div
            style={{
              fontSize: '18px',
              fontWeight: 'bold',
              wordWrap: 'break-word',
              textAlign: 'center',
              marginTop: schoolData.sansthaName ? '5px' : '-4px',
            }}
          >
            {schoolData.schoolName}
          </div>

        </div>
        <div
          style={{
            textAlign: "center",
            marginBottom: "10px",
            fontSize: "13.5px"
          }}
        >
          <p style={{ margin: "2px 0" }}>
            <b>{language === "English" ? "Taluka : " : "तालुका : "}</b>
            {schoolData.taluka},
            <b>{language === "English" ? " District : " : " जिल्हा : "}</b>
            {schoolData.jilha}
          </p>
          <p style={{ margin: "2px 0" }}>
            <b> {language === "English" ? "UDISE No : " : "UDISE क्र : "}</b>
            {schoolData.udiseNumber},
            <b> {language === "English" ? " Board : " : " बोर्ड : "}</b>
            {schoolData.boardName}
          </p>

          <div style={{ display: 'flex', flexDirection: isStacked ? 'column' : 'row', justifyContent: 'center', alignItems: 'center' }}>
            {schoolData.sanlagnataKramank && (
              <p ref={affiliationRef} style={{ margin: "2px 0", whiteSpace: isStacked ? 'normal' : 'nowrap' }}>
                <b>{language === "English" ? "Affiliation No : " : "संलग्नता क्र : "}</b>
                {schoolData.sanlagnataKramank}
              </p>
            )}
            {schoolData.schoolCode && (
              <p style={{ margin: "2px 0", whiteSpace: isStacked ? 'normal' : 'nowrap', marginLeft: isStacked ? '0' : '10px' }}>
                <b>{language === "English" ? " School Code : " : " शाळा कोड : "}</b>
                {schoolData.schoolCode}
              </p>
            )}
          </div>

        </div>
        <div
          style={{
            position: "absolute",
            top: "1.6in",
            left: "0in",
            width: "7.55in",
            height: "0in",
            textAlign: "center",
            border: "0.01in solid black",
            margin: "10px 0",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "2.9in",
            width: "2in",
            height: "0.3in",
            textAlign: "center",
            border: "0.02in solid black",
            margin: "10px 0",
            backgroundColor: 'black', // add this
            color: 'white', // add this
            borderRadius: '0.1in', // add this
          }}
        >
          <h3
            style={{
              color: "white",
              fontSize: "14px",
              margin: "5px 0",
              fontWeight: "bold",

            }}
          >
            {language === "English" ? "Bonafide Certificate" : "बोनाफाईड प्रमाणपत्र"}
          </h3>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "0.1in",
          }}
        >
          {formData.showOwtId === true && (
            <p style={{ margin: "5px 0" }}>
              <b> {language === "English" ? "O.W. No. : " : "जावक क्र. : "}</b>
              {formData.owtId || 'Not Generated'}
            </p>
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "5.2in",
          }}
        >
          <p style={{ margin: "5px 0" }}>
            <b> {language === "English" ? "Date : " : "दिनांक : "}</b>
            {formData.date ? moment(formData.date).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY')}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.8in",
            left: "0.1in"
          }}
        >
          <p>
            <b> {language === "English" ? "GR. No. :  " : "रजिस्टर क्र :  "}</b>
            {formData.registerno}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.8in",
            left: "5.2in",
          }}
        >
          <p>
            <b> {language === "English" ? "Aadhar No : " : " आधार क्र : "}</b>
            {formData.stdAdharNo}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "2.0in",
            left: "0.1in"
          }}
        >
          <p>
            <b> {language === "English" ? "Pen No : " : "पेन आयडी : "}</b>
            {formData.panId}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "2.0in",
            left: "5.2in",
          }}
        >
          <p>
            <b> {language === "English" ? "Apaar Id : " : "अपार आयडी : "}</b>
            {formData.aparId}
          </p>
        </div>


        {isFreeTrial && (
          <img
            src={Watermark}
            alt="Free Trial Watermark"
            style={{
              position: "absolute",
              top: "60%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(10deg)",
              width: "50%",
              opacity: 0.2,
              pointerEvents: "none",
              zIndex: 0
            }}
          />
        )}


        <div
          style={{
            position: "absolute",
            top: "2.4in",
          }}
        >
          <p
            style={{
              margin: "5px 15px",
              position: "absolute",
              top: "-0.3in",
              left: language === "English" ? '2.89in' : "2.65in",
            }}
          >
            {" "}
            {language === "English"
              ? "It is certified that"
              : "प्रमाणित करण्यात येते की"}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong> {language === "English"
              ? "Full name of student : "
              : "विद्यार्थ्याचे पूर्ण नाव : "}
            </strong>
            {formData.stdName} {formData.stdFather} {formData.stdSurname}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Mother's name : " : "आईचे नाव : "}</strong>
            {formData.stdMother}
          </p>
          <p
            style={{
              margin: '5px 20px',
              position: 'absolute',
              top: '0.6in',
              left: '4.6in',
            }}
          >
            <strong> {language === "English" ? "Class : " : "वर्ग: "}</strong>
            {formData.class}, &nbsp;
            <strong>{language === "English" ? " Division : " : " तुकडी: "}</strong>
            {formData.division}
          </p>

          <p style={{ margin: '5px 20px' }}>
            <strong>{language === "English" ? "Academic Year : " : "शैक्षणिक वर्ष : "}</strong>
            {formData.educationalYear}
          </p>

          <p
            style={{
              margin: '5px 20px',
              position: 'absolute',
              top: '0.3in',
              left: '4.6in',
            }}
          >
            <strong>{language === "English" ? "Date of Birth : " : "जन्मतारीख : "}</strong>
            {moment(formData.dob).format('DD-MM-YYYY')}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong> {language === "English"
              ? "caste and religion : "
              : "जात व धर्म : "}</strong>
            {formData.religion}, {formData.caste}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong> {language === "English"
              ? "Reason : "
              : "कारण : "}</strong>
            {formData.reason}
          </p>

          <p style={{ marginTop: '20px', padding: '0 20px', fontSize: '16px', lineHeight: '1.6' }}>
            {language === "English"
              ? `This student belongs to our ${institutionWordEnglish} and all the information given above is correct. According to our information,  ${formData.gender === 'male' ? 'his' : 'her'} behavior is satisfactory.`
              : `वरील विद्यार्थी आमच्या ${institutionWordMarathi} शिकत आहे आणि वर दिलेली सर्व माहिती योग्य आहे. आमच्या माहितीप्रमाणे     ${formData.gender === 'male' ? 'त्याचे' : 'तिचे'} वर्तन समाधानकारक आहे.`}
          </p>
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
            position: "absolute",
            top: "4.5in",
            left: "5.8in",
          }}
        >
          {isPrincipal && isDean
            ? language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
            : isPrincipal
              ? language === "English" ? "Principal" : "मुख्याध्यापक"
              : isDean
                ? language === "English" ? "Dean" : "प्राचार्य"
                : language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
          }
          {/* <p style={{ margin: "0" }}>
          {isCollege && isSchool
            ? language === "English"
              ? "College/School"
              : "कॉलेज/शाळा"
            : isCollege
            ? language === "English"
              ? "College"
              : "कॉलेज"
            : isSchool
            ? language === "English"
              ? "School"
              : "शाळा"
            : language === "English"
              ? "College/School"
              : "कॉलेज/शाळा"
            }

             <br />
            {language === "English" ? "(Official Seal)" : " (अधिकृत शिक्का)"}
          </p> */}
        </div>
        {/* <div 
          style={{
            textAlign: "center",
            marginTop: "50px",
            position: "absolute", 
            top: "4.3in",
            left: "0.5in",
          }}
        >
          <p style={{ margin: "0"}}>
            {" "}
          <br/>

          {isPrincipal && isDean
            ? language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
            : isPrincipal
            ? language === "English" ? "Principal" : "मुख्याध्यापक"
            : isDean
            ? language === "English" ? "Dean" : "प्राचार्य"
            :language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
            }

          </p>
        </div> */}
      </div>
    );
  };




  const renderContent2 = () => {
    if (!schoolData || !formData) return null;

    return (
      <div
        style={{
          position: "absolute",
          top: "0.9in", // Move the box to the top of the page
          right: "0.30in",
          width: "7.6in", // 8.5in - 0.4in (0.2in on each side)
          height: "5.35in", // Adjust the height as needed
          padding: "0.2in", // Adjust padding to create the margin inside the border
          fontFamily: "'NotoSansDevanagari', sans-serif",
          border: "0.03in solid black",
          boxSizing: "border-box",


          '@media (max-width: 1200px)': {
            width: '7in', // Adjust width for medium screens
            height: '5in', // Adjust height for medium screens
          },
          '@media (max-width: 992px)': {
            width: '6.5in', // Adjust width for smaller screens
            height: '4.8in', // Adjust height for smaller screens
          },
          '@media (max-width: 768px)': {
            width: '6in',
            height: '4.6in',
          },
          '@media (max-width: 576px)': {
            width: '100%',
            left: '0.2in',
            height: 'auto',
          }
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "0.62in",
            left: "0.15in",
          }}
        >
          {logoURL && (
            <img
              src={logoURL}
              alt="School Logo"
              style={{ width: "100px", height: "100px" }}
            />
          )}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {schoolData.sansthaName && (
            <div
              style={{
                fontSize: '11px',
                fontWeight: 'bold',
                wordWrap: 'break-word',
                textAlign: 'center',
                marginTop: '-15px', // add this
              }}
            >
              {schoolData.sansthaName}
            </div>
          )}
          <div
            style={{
              fontSize: '18px',
              fontWeight: 'bold',
              wordWrap: 'break-word',
              textAlign: 'center',
              marginTop: schoolData.sansthaName ? '5px' : '-4px',
            }}
          >
            {schoolData.schoolName}
          </div>

        </div>
        <div
          style={{
            textAlign: "center",
            marginBottom: "10px",
            fontSize: "13.5px"
          }}
        >
          <p style={{ margin: "2px 0" }}>
            <b>{language === "English" ? "Taluka : " : "तालुका : "}</b>
            {schoolData.taluka},
            <b>{language === "English" ? " District : " : " जिल्हा : "}</b>
            {schoolData.jilha}
          </p>
          <p style={{ margin: "2px 0" }}>
            <b> {language === "English" ? "UDISE No : " : "UDISE क्र : "}</b>
            {schoolData.udiseNumber},
            <b> {language === "English" ? " Board : " : " बोर्ड : "}</b>
            {schoolData.boardName}
          </p>

          <div style={{ display: 'flex', flexDirection: isStacked ? 'column' : 'row', justifyContent: 'center', alignItems: 'center' }}>
            {schoolData.sanlagnataKramank && (
              <p ref={affiliationRef} style={{ margin: "2px 0", whiteSpace: isStacked ? 'normal' : 'nowrap' }}>
                <b>{language === "English" ? "Affiliation No : " : "संलग्नता क्र : "}</b>
                {schoolData.sanlagnataKramank}
              </p>
            )}
            {schoolData.manyataKramank && (
              <p ref={recognitionRef} style={{ margin: "2px 0", whiteSpace: isStacked ? 'normal' : 'nowrap' }}>
                <b>{language === "English" ? " Recognition No : " : " मान्यता क्र : "}</b>
                {schoolData.manyataKramank}
              </p>
            )}
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.6in",
            left: "0in",
            width: "7.55in",
            height: "0in",
            textAlign: "center",
            border: "0.01in solid black",
            margin: "10px 0",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "2.9in",
            width: "2in",
            height: "0.3in",
            textAlign: "center",
            border: "0.02in solid black",
            margin: "10px 0",
            backgroundColor: 'black', // add this
            color: 'white', // add this
            borderRadius: '0.1in', // add this
          }}
        >
          <h3
            style={{
              color: "white",
              fontSize: "14px",
              margin: "5px 0",
              fontWeight: "bold",

            }}
          >
            {language === "English" ? "Bonafide Certificate" : "बोनाफाईड प्रमाणपत्र"}
          </h3>

        </div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "0.1in",
          }}
        >
          {formData.showOwtId === true && (
            <p style={{ margin: "5px 0" }}>
              <b> {language === "English" ? "O.W. No. : " : "जावक क्र. : "}</b>
              {formData.owtId || 'Not Generated'}
            </p>
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "5.2in",
          }}
        >
          <p style={{ margin: "5px 0" }}>
            <b> {language === "English" ? "Date : " : "दिनांक : "}</b>
            {formData.date ? moment(formData.date).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY')}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.77in",
            left: "0.1in", fontSize: '15px'
          }}
        >
          <p>
            <b> {language === "English" ? "GR. No. :  " : "रजिस्टर क्र :  "}</b>
            {formData.registerno}
          </p>
        </div>

        <p
          style={{
            position: "absolute",
            top: "2.02in",
            left: "0.1in", fontSize: '15px'
          }}
        >
          <strong> {language === "English" ? "Class : " : "वर्ग: "}</strong>
          {formData.class}, &nbsp;
          <strong>{language === "English" ? " Division : " : " तुकडी: "}</strong>
          {formData.division}
        </p>


        <div
          style={{
            position: "absolute",
            top: "1.77in",
            left: "5.2in", fontSize: '15px'
          }}
        >
          <p>

            <b> {language === "English" ? "Aadhar No : " : " आधार क्र : "}</b>
            {formData.stdAdharNo}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "2.02in",
            left: "5.2in", fontSize: '15px'
          }}
        >
          <p>

            <strong>{language === "English" ? "Academic Year : " : "शैक्षणिक वर्ष : "}</strong>
            {formData.educationalYear}
          </p>
        </div>





        {isFreeTrial && (
          <img
            src={Watermark}
            alt="Free Trial Watermark"
            style={{
              position: "absolute",
              top: "60%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(10deg)",
              width: "50%",
              opacity: 0.2,
              pointerEvents: "none",
              zIndex: 0
            }}
          />
        )}


        <div
          style={{
            position: "absolute",
            top: "2.35in", fontSize: '15px'
          }}
        >
          <p
            style={{
              margin: "5px 15px",
              position: "absolute",
              top: "-0.4in",
              left: language === "English" ? '2.9in' : "2.7in",
            }}
          >
            {" "}
            {language === "English"
              ? "It is certified that"
              : "प्रमाणित करण्यात येते की"}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong> {language === "English"
              ? "Full name of student : "
              : "विद्यार्थ्याचे पूर्ण नाव : "}
            </strong>
            {formData.stdName} {formData.stdFather} {formData.stdSurname}

          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Mother's name : " : "आईचे नाव : "}</strong>
            {formData.stdMother}
          </p>


          <p
            style={{
              margin: '5px 20px',
              position: 'absolute',
              top: '0.25in',
              left: '3.5in',
            }}
          >
            <strong> {language === "English"
              ? "caste and religion : "
              : "जात व धर्म : "}</strong>
            {formData.religion}, {formData.caste}
          </p>


          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Date of Birth : " : "जन्मतारीख (अंकी व अक्षरी) : "}</strong>
            {moment(formData.dob).format('DD-MM-YYYY')} ({formData.dobInWords || ''})
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Birth Place : " : "जन्मस्थळ : "}</strong>
            {formData.birthPlace || ''}
          </p>


          <p style={{ margin: "5px 20px", marginTop: '34px' }}>
            <strong> {language === "English"
              ? "Reason : "
              : "कारण : "}</strong>
            {formData.reason}
          </p>

          <p style={{ marginTop: '20px', padding: '0 20px', fontSize: '16px', lineHeight: '1.6' }}>
            {language === "English"
              ? `This student belongs to our ${institutionWordEnglish} and all the information given above is correct. According to our information,  ${formData.gender === 'male' ? 'his' : 'her'} behavior is satisfactory.`
              : `वरील विद्यार्थी आमच्या ${institutionWordMarathi} शिकत आहे आणि वर दिलेली सर्व माहिती योग्य आहे. आमच्या माहितीप्रमाणे     ${formData.gender === 'male' ? 'त्याचे' : 'तिचे'} वर्तन समाधानकारक आहे.`}
          </p>
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
            position: "absolute",
            top: "4.3in",
            left: "5.8in",
          }}
        >
          <p style={{ margin: "0" }}>
            {isCollege && isSchool
              ? language === "English"
                ? "College/School"
                : "कॉलेज/शाळा"
              : isCollege
                ? language === "English"
                  ? "College"
                  : "कॉलेज"
                : isSchool
                  ? language === "English"
                    ? "School"
                    : "शाळा"
                  : language === "English"
                    ? "College/School"
                    : "कॉलेज/शाळा"
            }

            <br />
            {language === "English" ? "(Official Seal)" : " (अधिकृत शिक्का)"}
          </p>
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
            position: "absolute",
            top: "4.3in",
            left: "0.5in",
          }}
        >
          <p style={{ margin: "0" }}>
            {" "}
            <br />

            {isPrincipal && isDean
              ? language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
              : isPrincipal
                ? language === "English" ? "Principal" : "मुख्याध्यापक"
                : isDean
                  ? language === "English" ? "Dean" : "प्राचार्य"
                  : language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
            }

          </p>
        </div>
      </div>
    );
  };





  const renderContent3 = () => {
    if (!schoolData || !formData) return null;

    return (
      <div
        style={{
          position: "absolute",
          top: "0.9in", // Move the box to the top of the page
          right: "0.30in",
          width: "7.6in", // 8.5in - 0.4in (0.2in on each side)
          height: "5.35in", // Adjust the height as needed
          padding: "0.2in", // Adjust padding to create the margin inside the border
          fontFamily: "'NotoSansDevanagari', sans-serif",
          border: "0.03in solid black",
          boxSizing: "border-box",


          '@media (max-width: 1200px)': {
            width: '7in', // Adjust width for medium screens
            height: '5in', // Adjust height for medium screens
          },
          '@media (max-width: 992px)': {
            width: '6.5in', // Adjust width for smaller screens
            height: '4.8in', // Adjust height for smaller screens
          },
          '@media (max-width: 768px)': {
            width: '6in',
            height: '4.6in',
          },
          '@media (max-width: 576px)': {
            width: '100%',
            left: '0.2in',
            height: 'auto',
          }
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "0.62in",
            left: "0.15in",
          }}
        >
          {logoURL && (
            <img
              src={logoURL}
              alt="School Logo"
              style={{ width: "100px", height: "100px" }}
            />
          )}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {schoolData.sansthaName && (
            <div
              style={{
                fontSize: '11px',
                fontWeight: 'bold',
                wordWrap: 'break-word',
                textAlign: 'center',
                marginTop: '-15px', // add this
              }}
            >
              {schoolData.sansthaName}
            </div>
          )}
          <div
            style={{
              fontSize: '18px',
              fontWeight: 'bold',
              wordWrap: 'break-word',
              textAlign: 'center',
              marginTop: schoolData.sansthaName ? '5px' : '-4px',
            }}
          >
            {schoolData.schoolName}
          </div>

        </div>
        <div
          style={{
            textAlign: "center",
            marginBottom: "10px",
            fontSize: "13.5px"
          }}
        >
          <p style={{ margin: "2px 0" }}>
            <b>{language === "English" ? "Taluka : " : "तालुका : "}</b>
            {schoolData.taluka},
            <b>{language === "English" ? " District : " : " जिल्हा : "}</b>
            {schoolData.jilha}
          </p>
          <p style={{ margin: "2px 0" }}>
            <b> {language === "English" ? "UDISE No : " : "UDISE क्र : "}</b>
            {schoolData.udiseNumber},
            <b> {language === "English" ? " Board : " : " बोर्ड : "}</b>
            {schoolData.boardName}
          </p>

          <div style={{ display: 'flex', flexDirection: isStacked ? 'column' : 'row', justifyContent: 'center', alignItems: 'center' }}>
            {schoolData.sanlagnataKramank && (
              <p ref={affiliationRef} style={{ margin: "2px 0", whiteSpace: isStacked ? 'normal' : 'nowrap' }}>
                <b>{language === "English" ? "Affiliation No : " : "संलग्नता क्र : "}</b>
                {schoolData.sanlagnataKramank}
              </p>
            )}
            {schoolData.manyataKramank && (
              <p ref={recognitionRef} style={{ margin: "2px 0", whiteSpace: isStacked ? 'normal' : 'nowrap' }}>
                <b>{language === "English" ? " Recognition No : " : " मान्यता क्र : "}</b>
                {schoolData.manyataKramank}
              </p>
            )}
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.6in",
            left: "0in",
            width: "7.55in",
            height: "0in",
            textAlign: "center",
            border: "0.01in solid black",
            margin: "10px 0",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "2.9in",
            width: "2in",
            height: "0.3in",
            textAlign: "center",
            border: "0.02in solid black",
            margin: "10px 0",
            backgroundColor: 'black', // add this
            color: 'white', // add this
            borderRadius: '0.1in', // add this
          }}
        >
          <h3
            style={{
              color: "white",
              fontSize: "14px",
              margin: "5px 0",
              fontWeight: "bold",

            }}
          >
            {language === "English" ? "Bonafide Certificate" : "बोनाफाईड प्रमाणपत्र"}
          </h3>

        </div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "0.1in",
          }}
        >
          {formData.showOwtId === true && (
            <p style={{ margin: "5px 0" }}>
              <b> {language === "English" ? "O.W. No. : " : "जावक क्र. : "}</b>
              {formData.owtId || 'Not Generated'}
            </p>
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "5.2in",
          }}
        >
          <p style={{ margin: "5px 0" }}>
            <b> {language === "English" ? "Date : " : "दिनांक : "}</b>
            {formData.date ? moment(formData.date).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY')}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.77in",
            left: "0.1in", fontSize: '15px'
          }}
        >
          <p>
            <b> {language === "English" ? "GR. No. :  " : "रजिस्टर क्र :  "}</b>
            {formData.registerno}
          </p>
        </div>

        <p
          style={{
            position: "absolute",
            top: "2.02in",
            left: "0.1in", fontSize: '15px'
          }}
        >
          <strong> {language === "English" ? "Class : " : "वर्ग: "}</strong>
          {formData.class}, &nbsp;
          <strong>{language === "English" ? " Division : " : " तुकडी: "}</strong>
          {formData.division}
        </p>

        <div
          style={{
            position: "absolute",
            top: "1.75in",
            right: "0.1in",
          }}
        >
          {formData.stdPhoto && (
            <img
              src={formData.stdPhoto}
              alt="Student Photo"
              style={{ width: "80px", height: "80px" }}
            />
          )}
        </div>






        {isFreeTrial && (
          <img
            src={Watermark}
            alt="Free Trial Watermark"
            style={{
              position: "absolute",
              top: "60%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(10deg)",
              width: "50%",
              opacity: 0.2,
              pointerEvents: "none",
              zIndex: 0
            }}
          />
        )}


        <div
          style={{
            position: "absolute",
            top: "2.35in", fontSize: '15px'
          }}
        >
          <p
            style={{
              margin: "5px 15px",
              position: "absolute",
              top: "-0.4in",
              left: language === "English" ? '2.9in' : "2.7in",
            }}
          >
            {" "}
            {language === "English"
              ? "It is certified that"
              : "प्रमाणित करण्यात येते की"}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong> {language === "English"
              ? "Full name of student : "
              : "विद्यार्थ्याचे पूर्ण नाव : "}
            </strong>
            {formData.stdName} {formData.stdFather} {formData.stdSurname}

          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Mother's name : " : "आईचे नाव : "}</strong>
            {formData.stdMother}
          </p>


          <p
            style={{
              margin: '5px 20px',
              position: 'absolute',
              top: '0.25in',
              left: '3.5in',
            }}
          >
            <strong> {language === "English"
              ? "caste and religion : "
              : "जात व धर्म : "}</strong>
            {formData.religion}, {formData.caste}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Aadhar No : " : " आधार क्र : "}</strong>
            {formData.stdAdharNo || ''}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Academic Year : " : "शैक्षणिक वर्ष : "}</strong>
            {formData.educationalYear || ''}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Date of Birth : " : "जन्मतारीख (अंकी व अक्षरी) : "}</strong>
            {moment(formData.dob).format('DD-MM-YYYY')} ({formData.dobInWords || ''})
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Birth Place : " : "जन्मस्थळ : "}</strong>
            {formData.birthPlace || ''}
          </p>



          <p style={{ margin: "5px 20px", marginTop: '10px' }}>
            <strong> {language === "English"
              ? "Reason : "
              : "कारण : "}</strong>
            {formData.reason}
          </p>

          <p style={{ marginTop: '20px', padding: '0 20px', fontSize: '16px', lineHeight: '1.6' }}>
            {language === "English"
              ? `This student belongs to our ${institutionWordEnglish} and all the information given above is correct. According to our information,  ${formData.gender === 'male' ? 'his' : 'her'} behavior is satisfactory.`
              : `वरील विद्यार्थी आमच्या ${institutionWordMarathi} शिकत आहे आणि वर दिलेली सर्व माहिती योग्य आहे. आमच्या माहितीप्रमाणे     ${formData.gender === 'male' ? 'त्याचे' : 'तिचे'} वर्तन समाधानकारक आहे.`}
          </p>
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
            position: "absolute",
            top: "4.3in",
            left: "5.8in",
          }}
        >
          <p style={{ margin: "0" }}>
            {isCollege && isSchool
              ? language === "English"
                ? "College/School"
                : "कॉलेज/शाळा"
              : isCollege
                ? language === "English"
                  ? "College"
                  : "कॉलेज"
                : isSchool
                  ? language === "English"
                    ? "School"
                    : "शाळा"
                  : language === "English"
                    ? "College/School"
                    : "कॉलेज/शाळा"
            }

            <br />
            {language === "English" ? "(Official Seal)" : " (अधिकृत शिक्का)"}
          </p>
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
            position: "absolute",
            top: "4.3in",
            left: "0.5in",
          }}
        >
          <p style={{ margin: "0" }}>
            {" "}
            <br />

            {isPrincipal && isDean
              ? language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
              : isPrincipal
                ? language === "English" ? "Principal" : "मुख्याध्यापक"
                : isDean
                  ? language === "English" ? "Dean" : "प्राचार्य"
                  : language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
            }

          </p>
        </div>
      </div>
    );
  };







  const renderContent4 = () => {
    if (!schoolData || !formData) return null;

    return (
      <div
        style={{
          position: "absolute",
          top: "0.9in", // Move the box to the top of the page
          right: "0.30in",
          width: "7.6in", // 8.5in - 0.4in (0.2in on each side)
          height: "5.35in", // Adjust the height as needed
          padding: "0.2in", // Adjust padding to create the margin inside the border
          fontFamily: "'NotoSansDevanagari', sans-serif",
          border: "0.03in solid black",
          boxSizing: "border-box",


          '@media (max-width: 1200px)': {
            width: '7in', // Adjust width for medium screens
            height: '5in', // Adjust height for medium screens
          },
          '@media (max-width: 992px)': {
            width: '6.5in', // Adjust width for smaller screens
            height: '4.8in', // Adjust height for smaller screens
          },
          '@media (max-width: 768px)': {
            width: '6in',
            height: '4.6in',
          },
          '@media (max-width: 576px)': {
            width: '100%',
            left: '0.2in',
            height: 'auto',
          }
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "0.32in",
            left: "0.15in",
          }}
        >
          {logoURL && (
            <img
              src={logoURL}
              alt="School Logo"
              style={{ width: "100px", height: "100px" }}
            />
          )}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {schoolData.sansthaName && (
            <div
              style={{
                fontSize: '11px',
                fontWeight: 'bold',
                wordWrap: 'break-word',
                textAlign: 'center',
                marginTop: '-15px', // add this
              }}
            >
              {schoolData.sansthaName}
            </div>
          )}
          <div
            style={{
              fontSize: '18px',
              fontWeight: 'bold',
              wordWrap: 'break-word',
              textAlign: 'center',
              marginTop: schoolData.sansthaName ? '5px' : '-4px',
            }}
          >
            {schoolData.schoolName}
          </div>

        </div>
        <div
          style={{
            textAlign: "center",
            marginBottom: "10px",
            fontSize: "13.5px"
          }}
        >
          <p style={{ margin: "2px 0" }}>
            <b>{language === "English" ? "Taluka : " : "तालुका : "}</b>
            {schoolData.taluka},
            <b>{language === "English" ? " District : " : " जिल्हा : "}</b>
            {schoolData.jilha}
          </p>
          <p style={{ margin: "2px 0" }}>
            <b> {language === "English" ? "UDISE No : " : "UDISE क्र : "}</b>
            {schoolData.udiseNumber},
            <b> {language === "English" ? " Board : " : " बोर्ड : "}</b>
            {schoolData.boardName}
          </p>

          <div style={{ display: 'flex', flexDirection: isStacked ? 'column' : 'row', justifyContent: 'center', alignItems: 'center' }}>
            {/* {schoolData.sanlagnataKramank && (
              <p ref={affiliationRef} style={{ margin: "2px 0", whiteSpace: isStacked ? 'normal' : 'nowrap' }}>
                <b>{language === "English" ? "Affiliation No : " : "संलग्नता क्र : "}</b>
                {schoolData.sanlagnataKramank}
              </p>
            )} */}
            {/* {schoolData.manyataKramank && (
              <p ref={recognitionRef} style={{ margin: "2px 0", whiteSpace: isStacked ? 'normal' : 'nowrap' }}>
                <b>{language === "English" ? " Recognition No : " : " मान्यता क्र : "}</b>
                {schoolData.manyataKramank}
              </p>
            )} */}
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.3in",
            left: "0in",
            width: "7.55in",
            height: "0in",
            textAlign: "center",
            border: "0.01in solid black",
            margin: "10px 0",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: "1.15in",
            left: "2.9in",
            width: "2in",
            height: "0.3in",
            textAlign: "center",
            border: "0.02in solid black",
            margin: "10px 0",
            backgroundColor: 'black', // add this
            color: 'white', // add this
            borderRadius: '0.1in', // add this
          }}
        >
          <h3
            style={{
              color: "white",
              fontSize: "14px",
              margin: "5px 0",
              fontWeight: "bold",

            }}
          >
            {language === "English" ? "Bonafide Certificate" : "बोनाफाईड प्रमाणपत्र"}
          </h3>

        </div>
        <div
          style={{
            position: "absolute",
            top: "1.15in",
            left: "0.1in",
          }}
        >
          {formData.showOwtId === true && (
            <p style={{ margin: "5px 0" }}>
              <b> {language === "English" ? "O.W. No. : " : "जावक क्र. : "}</b>
              {formData.owtId || 'Not Generated'}
            </p>
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.15in",
            left: "5.2in",
          }}
        >
          <p style={{ margin: "5px 0" }}>
            <b> {language === "English" ? "Date : " : "दिनांक : "}</b>
            {formData.date ? moment(formData.date).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY')}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.5in",
            left: "0.1in", fontSize: '15px'
          }}
        >
          <p>
            <b> {language === "English" ? "GR. No. :  " : "रजिस्टर क्र :  "}</b>
            {formData.registerno}
          </p>
        </div>

        <p
          style={{
            position: "absolute",
            top: "1.75in",
            left: "0.1in", fontSize: '15px'
          }}
        >
          <strong> {language === "English" ? "Class : " : "वर्ग: "}</strong>
          {formData.class}, &nbsp;
          <strong>{language === "English" ? " Division : " : " तुकडी: "}</strong>
          {formData.division}
        </p>

        <div
          style={{
            position: "absolute",
            top: "1.75in",
            right: "0.1in",
          }}
        >
          {formData.stdPhoto && (
            <img
              src={formData.stdPhoto}
              alt="Student Photo"
              style={{ width: "80px", height: "80px" }}
            />
          )}
        </div>






        {isFreeTrial && (
          <img
            src={Watermark}
            alt="Free Trial Watermark"
            style={{
              position: "absolute",
              top: "60%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(10deg)",
              width: "50%",
              opacity: 0.2,
              pointerEvents: "none",
              zIndex: 0
            }}
          />
        )}


        <div
          style={{
            position: "absolute",
            top: "2.02in", fontSize: '15px'
          }}
        >
          <p
            style={{
              margin: "5px 15px",
              position: "absolute",
              top: "-0.4in",
              left: language === "English" ? '2.9in' : "2.7in",
            }}
          >
            {" "}
            {language === "English"
              ? "This is certified that"
              : "प्रमाणित करण्यात येते की"}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong> {language === "English"
              ? "Full name of student : "
              : "विद्यार्थ्याचे पूर्ण नाव : "}
            </strong>
            {formData.stdName} {formData.stdFather} {formData.stdSurname}

          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Mother's name : " : "आईचे नाव : "}</strong>
            {formData.stdMother}
            <span style={{ marginLeft: '40px' }}>
              <strong> {language === "English" ? "caste : " : "जात : "}</strong>
              {formData.caste}
            </span>
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Aadhar No : " : " आधार क्र : "}</strong>
            {formData.stdAdharNo || ''}
            <span style={{ marginLeft: '40px' }}>
              <strong> {language === "English" ? "Pen No : " : "पेन आयडी : "}</strong>
              {formData.panId}
            </span>
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Apaar Id : " : "अपार आयडी : "}</strong>
            {formData.aparId}
            <span style={{ marginLeft: '40px' }}>
              <strong> {language === "English" ? "Saral Id : " : "सरल आयडी : "}</strong>
              {formData.studentId}
            </span>
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Academic Year : " : "शैक्षणिक वर्ष : "}</strong>
            {formData.educationalYear || ''}
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Date of Birth : " : "जन्मतारीख (अंकी व अक्षरी) : "}</strong>
            {moment(formData.dob).format('DD-MM-YYYY')} ({formData.dobInWords || ''})
          </p>

          <p style={{ margin: "5px 20px" }}>
            <strong>{language === "English" ? "Birth Place : " : "जन्मस्थळ : "}</strong>
            {formData.birthPlace || ''}
          </p>

          <p style={{ margin: "5px 20px", marginTop: '10px' }}>
            <strong> {language === "English"
              ? "Reason : "
              : "कारण : "}</strong>
            {formData.reason}
          </p>

          <p style={{ marginTop: '20px', padding: '0 20px', fontSize: '16px', lineHeight: '1.6' }}>
            {language === "English"
              ? `This student belongs to our ${institutionWordEnglish} and all the information given above is correct.`
              : `वरील विद्यार्थी आमच्या ${institutionWordMarathi} शिकत आहे आणि वर दिलेली सर्व माहिती योग्य आहे.`}
          </p>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
            position: "absolute",
            top: "4.3in",
            left: "5.8in",
          }}
        >
          <p style={{ margin: "0" }}>
            {" "}
            <br />
            {isPrincipal && isDean
              ? language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
              : isPrincipal
                ? language === "English" ? "Principal" : "मुख्याध्यापक"
                : isDean
                  ? language === "English" ? "Dean" : "प्राचार्य"
                  : language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
            }
          </p>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
            position: "absolute",
            top: "4.3in",
            left: "3.1in",
          }}
        >
          <p style={{ margin: "0" }}>
            <br />
            {language === "English" ? "Class Teacher " : "वर्गशिक्षक"}
          </p>
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
            position: "absolute",
            top: "4.3in",
            left: "0.5in",
          }}
        >
          <p style={{ margin: "0" }}>
            {isCollege && isSchool
              ? language === "English"
                ? "College/School"
                : "कॉलेज/शाळा"
              : isCollege
                ? language === "English"
                  ? "College"
                  : "कॉलेज"
                : isSchool
                  ? language === "English"
                    ? "School"
                    : "शाळा"
                  : language === "English"
                    ? "College/School"
                    : "कॉलेज/शाळा"
            }
            <br />
            {language === "English" ? "(Official Seal)" : " (अधिकृत शिक्का)"}
          </p>
        </div>
      </div>
    );
  };

  const renderContent5 = () => {
    if (!schoolData || !formData) return null;

    return (
      <div
        style={{
          position: "absolute",
          top: "0.9in", // Move the box to the top of the page
          right: "0.30in",
          width: "7.6in", // 8.5in - 0.4in (0.2in on each side)
          height: "5.35in", // Adjust the height as needed
          padding: "0.2in", // Adjust padding to create the margin inside the border
          fontFamily: "'NotoSansDevanagari', sans-serif",
          border: "0.03in solid black",
          boxSizing: "border-box",

          '@media (max-width: 1200px)': {
            width: '7in', // Adjust width for medium screens
            height: '5in', // Adjust height for medium screens
          },
          '@media (max-width: 992px)': {
            width: '6.5in', // Adjust width for smaller screens
            height: '4.8in', // Adjust height for smaller screens
          },
          '@media (max-width: 768px)': {
            width: '6in',
            height: '4.6in',
          },
          '@media (max-width: 576px)': {
            width: '100%',
            left: '0.2in',
            height: 'auto',
          }
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "0.55in",
            left: "0.081in",
          }}
        >
          {logoURL && (
            <img
              src={logoURL}
              alt="School Logo"
              style={{ width: "100px", height: "100px" }}
            />
          )}
        </div>

        <div
          style={{
            position: "absolute",
            top: "0.55in",
            right: "0.081in",
          }}
        >
          {logoURL2 && (
            <img
              src={logoURL2}
              alt="School Logo"
              style={{ width: "100px", height: "100px" }}
            />
          )}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {schoolData.sansthaName && (
            <div
              style={{
                fontSize: '11px',
                fontWeight: 'bold',
                wordWrap: 'break-word',
                textAlign: 'center',
                marginTop: '-15px', // add this
              }}
            >
              {schoolData.sansthaName}
            </div>
          )}
          <div
            style={{
              fontSize: '18px',
              fontWeight: 'bold',
              wordWrap: 'break-word',
              textAlign: 'center',
              marginTop: schoolData.sansthaName ? '5px' : '-4px',
            }}
          >
            {schoolData.schoolName}
          </div>

        </div>
        <div
          style={{
            textAlign: "center",
            marginBottom: "10px",
            fontSize: "13.5px"
          }}
        >
          <p style={{ margin: "2px 0" }}>
            {language === 'English' ? (
              <>
                <strong>Taluka : </strong>{schoolData.taluka}, <strong>District :</strong> {schoolData.jilha}, <strong>Pin Code :</strong> {schoolData.pincode}
              </>
            ) : (
              <>
                <strong>तालुका : </strong>{schoolData.taluka}, <strong>जिल्हा :</strong> {schoolData.jilha}, <strong>पिनकोड :</strong> {schoolData.pincode}
              </>
            )}
          </p>
          {schoolData.sanlagnataKramank && (
            <p ref={affiliationRef} style={{ margin: "2px 0" }}>
              {language === 'English' ? (
                <>
                  Affiliated by {schoolData.sanlagnataKramank}
                </>
              ) : (
                <>
                  संलग्नता {schoolData.sanlagnataKramank}
                </>
              )}
            </p>
          )}
          {schoolData.udiseNumber && (
            <p style={{ margin: "2px 0" }}>
              {language === 'English' ? (
                <>
                  <strong>College Code No :</strong> {schoolData.udiseNumber}
                </>
              ) : (
                <>
                  <strong>कॉलेज  कोड क्र. :</strong> {schoolData.udiseNumber}
                </>
              )}
            </p>
          )}

        </div>
        <div
          style={{
            position: "absolute",
            top: "1.6in",
            left: "0in",
            width: "7.55in",
            height: "0in",
            textAlign: "center",
            border: "0.01in solid black",
            margin: "10px 0",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "2.9in",
            width: "2in",
            height: "0.3in",
            textAlign: "center",
            border: "0.02in solid black",
            margin: "10px 0",
            backgroundColor: 'black', // add this
            color: 'white', // add this
            borderRadius: '0.1in', // add this
          }}
        >
          <h3
            style={{
              color: "white",
              fontSize: "14px",
              margin: "5px 0",
              fontWeight: "bold",

            }}
          >
            {language === "English" ? "Bonafide Certificate" : "बोनाफाईड प्रमाणपत्र"}
          </h3>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "0.1in",
          }}
        >
          <p style={{ margin: "5px 0" }}>
            <b> {language === "English" ? "Sr. No. : " : "अनु. क्र. : "}</b>
            {formData.serialNo}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.45in",
            left: "5.2in",
          }}
        >
          <p style={{ margin: "5px 0" }}>
            <b> {language === "English" ? "Date : " : "दिनांक : "}</b>
            {formData.date ? moment(formData.date).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY')}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "1.8in",
            left: "0.1in"
          }}
        >
          <p>
            <b> {language === "English" ? "GR. No. :  " : "रजिस्टर क्र :  "}</b>
            {formData.registerno}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            top: "2.05in",
            left: "0.1in"
          }}
        >
          <p>
            <b> {language === "English" ? "Class : " : "वर्ग: "}</b>
            {formData.class}
          </p>
        </div>

        <div
          style={{
            position: "absolute",
            top: "1.75in",
            right: "0.2in",
            border: "1px solid black",
            width: "85px",
            height: "105px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f9f9f9"
          }}
        >
          {formData.stdPhoto ? (
            <img
              src={formData.stdPhoto}
              alt="Student Photo"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <span style={{ fontSize: "10px", color: "gray" }}>Photo</span>
          )}
        </div>

        {isFreeTrial && (
          <img
            src={Watermark}
            alt="Free Trial Watermark"
            style={{
              position: "absolute",
              top: "60%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(10deg)",
              width: "50%",
              opacity: 0.2,
              pointerEvents: "none",
              zIndex: 0
            }}
          />
        )}

        <p
          style={{
            position: "absolute",
            top: "1.9in",
            left: "0",
            right: "0",
            textAlign: "center",
            margin: "0",
          }}
        >
          {language === "English"
            ? "This is certified that"
            : "प्रमाणित करण्यात येते की"}
        </p>

        <div
          style={{
            position: "absolute",
            top: "2.45in",
            left: "0.1in",
            width: "7.2in",
          }}
        >
          <p style={{ margin: "3px 20px", paddingRight: "1.1in" }}>
            <strong> {language === "English"
              ? "Full name of student : "
              : "विद्यार्थ्याचे पूर्ण नाव : "}
            </strong>
            {formData.stdName} {formData.stdFather} {formData.stdSurname}
          </p>

          <p style={{ margin: "3px 20px", paddingRight: "1.1in" }}>
            <strong>{language === "English" ? "PRN No : " : "PRN क्र : "}</strong>
            {formData.panId}
          </p>

          <p style={{ margin: "3px 20px", paddingRight: "1.1in" }}>
            <strong>{language === "English" ? "Academic Year : " : "शैक्षणिक वर्ष : "}</strong>
            {formData.educationalYear}
          </p>

          <p style={{ margin: "3px 20px" }}>
            <strong>{language === "English" ? "Date of Birth : " : "जन्मतारीख (अंकी व अक्षरी) : "}</strong>
            {moment(formData.dob).format('DD-MM-YYYY')} ({formData.dobInWords || ''})
          </p>

          <p style={{ margin: "3px 20px" }}>
            <strong> {language === "English"
              ? "caste and religion : "
              : "जात व धर्म : "}</strong>
            {formData.religion}, {formData.caste}
          </p>
        </div>

        <p
          style={{
            position: "absolute",
            top: "3.9in",
            left: "0.1in",
            right: "0.1in",
            padding: "0 20px",
            margin: "0",
            fontSize: '16px',
            lineHeight: '1.6'
          }}
        >
          {language === "English"
            ? `This student belongs to our ${institutionWordEnglish} and all the information given above is correct.`
            : `वरील विद्यार्थी आमच्या ${institutionWordMarathi} शिकत आहे आणि वर दिलेली सर्व माहिती योग्य आहे.`}
        </p>

        <div
          style={{
            textAlign: "center",
            position: "absolute",
            top: "4.7in",
            left: "0.5in",
          }}
        >
          {isPrincipal && isDean
            ? language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
            : isPrincipal
              ? language === "English" ? "Principal" : "मुख्याध्यापक"
              : isDean
                ? language === "English" ? "Dean" : "प्राचार्य"
                : language === "English" ? "Principal / Dean" : "प्राचार्य /मुख्याध्यापक"
          }
        </div>
        <div
          style={{
            textAlign: "center",
            position: "absolute",
            top: "4.7in",
            left: "5.8in",
          }}
        >
          <p style={{ margin: "0" }}>
            {isCollege && isSchool
              ? language === "English"
                ? "College/School"
                : "कॉलेज/शाळा"
              : isCollege
                ? language === "English"
                  ? "College"
                  : "कॉलेज"
                : isSchool
                  ? language === "English"
                    ? "School"
                    : "शाळा"
                  : language === "English"
                    ? "College/School"
                    : "कॉलेज/शाळा"
            }
            <br />
            {language === "English" ? "(Official Seal)" : " (अधिकृत शिक्का)"}
          </p>
        </div>
      </div>
    );
  };

  const themes = [renderContent, renderContent2, renderContent3, renderContent4, renderContent5]; // Array of theme render functions
  // const themes = [renderContent, renderContent3]; // Array of theme render functions

  useEffect(() => {
    const savedThemeIndex = localStorage.getItem('defaultThemeIndex');
    const savedIsDefault = localStorage.getItem('isDefaultTheme') === 'true';

    if (savedThemeIndex) {
      setCurrentThemeIndex(Number(savedThemeIndex));
    }
    setIsDefaultTheme(savedIsDefault);
  }, []);

  const handleDefaultThemeChange = (event) => {
    const checked = event.target.checked;
    setIsDefaultTheme(checked);
    localStorage.setItem('isDefaultTheme', checked);
    if (checked) {
      localStorage.setItem('defaultThemeIndex', currentThemeIndex);
    } else {
      localStorage.removeItem('defaultThemeIndex');
    }
  };


  const checkForDuplicates = async (serialNo) => {
    const baseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}`;
    const existingSerialNoUrl = `${baseUrl}/BonafideStd/${serialNo}.json`;

    try {
      const response = await fetch(existingSerialNoUrl);
      if (!response.ok) {
        setDuplicate(false);
        return;
      }

      const serialNoData = await response.json();
      if (!serialNoData) {
        setDuplicate(false);
        return;
      }

      const multipleEntries = Object.keys(serialNoData).length > 1 ||
        Object.values(serialNoData).some(value => Array.isArray(value));

      setDuplicate(multipleEntries);
    } catch (error) {
      console.error('Error checking for duplicates:', error);
      setDuplicate(false);
    }
  };

  useEffect(() => {
    if (formData.serialNo) {
      checkForDuplicates(formData.serialNo);
    } else {
      setDuplicate(false);
    }
  }, [formData.serialNo]);

  // Modified getNextDocumentNumber function
  const getNextDocumentNumber = async (serialNo) => {
    const udiseNumber = localStorage.getItem("udiseNumber");
    const baseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}`;
    const lastDocUrl = `${baseUrl}/lastBonafideDocumentNo.json`;

    try {
      // Fetch current document number
      const response = await fetch(lastDocUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch current document number');
      }

      const currentNumber = await response.json() || 0;
      const nextNumber = currentNumber + 1;

      // Update the last document number in Firebase
      await fetch(lastDocUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(nextNumber),
      });

      // Format the document number
      const year = new Date().getFullYear();
      const formattedNumber = `BONAFIDE/${year}/${String(nextNumber).padStart(5, '0')}`;

      // Get formatted date
      const formattedDate = moment(formData.date).format('DD-MM-YYYY');

      // Check if the serialNo already exists
      const existingSerialNoUrl = `${baseUrl}/BonafideStd/${formData.serialNo}.json`;
      const existingSerialNoResponse = await fetch(existingSerialNoUrl);

      if (existingSerialNoResponse.ok) {
        const existingSerialNoData = await existingSerialNoResponse.json();

        // Handle multiple certificates on the same day
        if (existingSerialNoData && existingSerialNoData[formattedDate]) {
          // If this date already has entries, we need to store as an array
          let dateEntries;

          if (Array.isArray(existingSerialNoData[formattedDate])) {
            // If it's already an array, add to it
            dateEntries = [...existingSerialNoData[formattedDate], formattedNumber];
          } else {
            // If it's a single value, convert to array with both values
            dateEntries = [existingSerialNoData[formattedDate], formattedNumber];
          }

          const newDate = {};
          newDate[formattedDate] = dateEntries;

          await fetch(existingSerialNoUrl, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(newDate),
          });
        } else {
          // If this date doesn't exist yet, add it as a single value
          const newDate = {};
          newDate[formattedDate] = formattedNumber;

          await fetch(existingSerialNoUrl, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(newDate),
          });
        }
        const updatedSerialNoResponse = await fetch(existingSerialNoUrl);
        if (updatedSerialNoResponse.ok) {
          const updatedData = await updatedSerialNoResponse.json();
          const hasDuplicates = Object.keys(updatedData).length > 1 ||
            Object.values(updatedData).some(value => Array.isArray(value));
          setDuplicate(hasDuplicates);
        }
      } else {
        setDuplicate(false);

        const newSerialNo = {};
        newSerialNo[formattedDate] = formattedNumber;

        await fetch(existingSerialNoUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(newSerialNo),
        });
      }

      return formattedNumber;
    } catch (error) {
      console.error('Error managing document number:', error);
      return null;
    }
  };



  const printCertificate = async () => {
    try {
      if (!isStudentActive) {
        setAlertMessage('Cannot print certificate for inactive students.');
        return;
      }

      // Ensure form data is valid
      if (!formData.registerno || !formData.stdName) {
        setAlertMessage('Please fill in all required fields before printing.');
        return;
      }

      // Get the next document number
      const newDocNumber = await getNextDocumentNumber();
      if (!newDocNumber) {
        setAlertMessage('Error generating document number.');
        return;
      }


      const lastDocUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastBonafideDocumentNo.json`;
      const lastDocResponse = await fetch(lastDocUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(parseInt(newDocNumber.split('/')[2], 10)), // Extract the numeric part of the document number
      });

      if (!lastDocResponse.ok) {
        throw new Error('Failed to update lastBonafideDocumentNo in Firebase.');
      }


      // New logic for handling outward ID
      const outwardIdBaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/outwardIds`;
      const outwardIdResponse = await fetch(outwardIdBaseUrl + '.json');
      const outwardIdData = await outwardIdResponse.json() || {};
      // Get the current outward ID or initialize it
      const currentOutwardId = outwardIdData.current || 0;
      const nextOutwardId = currentOutwardId + 1;
      // Prepare the data to store
      const outwardIdEntry = {
        serialNo: formData.serialNo,
        reason: formData.reason,
        documentNumber: newDocNumber,
        date: moment().format('DD-MM-YYYY'), // Use current date
      };
      // Store the new outward ID and its details
      await fetch(outwardIdBaseUrl + `/${nextOutwardId}.json`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(outwardIdEntry),
      });
      // Update the current outward ID in the database
      await fetch(outwardIdBaseUrl + '/current.json', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(nextOutwardId),
      });




      // Print the certificate
      const printContent = document.getElementById("print-content");
      const originalContent = document.body.innerHTML;

      // Apply CSS styles directly to the print content for positioning
      printContent.style.padding = "50px 381px"; // Shift content to the right and up
      printContent.style.transform = "translate(0, -90px) scale(1.08)"; // Slightly move content upwards

      document.body.innerHTML = printContent.outerHTML; // Replace body with print content

      window.print();

      document.body.innerHTML = originalContent; // Restore the original content
      window.location.reload();

      setAlertMessage('Bonafide certificate printed and saved successfully!');
    } catch (error) {
      console.error('Error in printCertificate:', error);
      setAlertMessage('An error occurred while printing and saving the certificate.');
    }
  };

  return (
    <>
      <AlertMessage message={alertMessage} show={showAlert} />
      <div
        className="main-content-of-page"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1em",
          marginBottom: "20px"
        }}
      >

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '400px', textAlign: 'left', left: '11%', position: 'absolute', }}>
          <button
            onClick={printCertificate}
            style={{
              position: "relative",
              top: 0,
              left: '10px',
              cursor: isStudentActive ? "pointer" : "not-allowed",
              opacity: isStudentActive ? 1 : 0.5,
            }} disabled={!isStudentActive}
          >
            Print
          </button>


          <div style={{ marginTop: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              {themes.map((_, index) => (
                <button
                  key={index}
                  className="theme-button"
                  onClick={() => {
                    setCurrentThemeIndex(index);
                    setIsDefaultTheme(false);
                  }}
                  style={{
                    backgroundColor: currentThemeIndex === index ? '#03365e' : '#cccccc',
                    color: currentThemeIndex === index ? 'white' : 'black',
                  }}
                >
                  {index + 1}
                </button>
              ))}
            </div>

            <label style={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: '10px' }}>
              <span style={{ width: '9%' }}>
                <input
                  type="checkbox"
                  checked={isDefaultTheme}
                  onChange={handleDefaultThemeChange}
                  style={{ width: '100%' }}
                />
              </span>

              <span style={{ width: '91%', color: 'gray' }}>
                Set as default theme
              </span>
            </label>
          </div>

          <style jsx>{`
  .theme-button {
    padding: 0px 7px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
  }

  .theme-button:hover {
    opacity: 0.9;
  }
`}</style>
        </div>
        <div id="print-content" style={{ marginBottom: '280px' }}>
          {loading ? <p>Loading...</p> : themes[currentThemeIndex]()}
        </div>
      </div>

    </>
  );

}

export default Bonadoc;
